<template>
  <div>
    <b-row>
      <b-col xxs="12" class="d-flex align-items-center justify-content-between">
        <h3 class="mt-2">{{ title }}</h3>
        <b-button variant="primary" @click="showModal">{{ $t("Yeni Oluştur") }}</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="items" responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz hiç kategori eklememişsiniz, hemen yeni bir tane ekleyin") }}!</b-alert>
          </template>

          <template v-slot:cell(action)="data">
            <b-button variant="info" size="sm" @click="openModal(data.item)">{{ $t("Düzenle") }}</b-button>
            <b-button variant="danger" size="sm" @click="deleteAction(data.item.id)">{{ $t("Sil") }}</b-button>
          </template>

        </b-table>
      </b-col>
    </b-row>
    <Pagination v-if="lastPage>1" :cPage="currentPage" @changePage="changePage" :last_page="lastPage" />

    <b-row v-if="totalRows > 14">
      <b-col class="d-flex justify-content-center">
        <b-pagination v-model="currentPage" :per-page="15" :total-rows="totalRows"></b-pagination>
      </b-col>
    </b-row>

    <b-modal ref="modal" :title="title" @hide="hideModal">
      <b-form-group label="Başlık">
        <b-form-input v-model="modal.name"></b-form-input>
      </b-form-group>
<!--      <b-form-group label="Üst Kategori">-->
<!--        <v-select v-model="modal.parent" :options="categoryOptions"></v-select>-->
<!--      </b-form-group>-->
      <template v-slot:modal-footer>
        <b-button @click="$refs.modal.hide()">İptal</b-button>
        <b-button @click="submit()" variant="primary" class="loading-button">
          <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t("Kaydet") }}
          </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Pagination from "../../components/Pagination";
  export default {
    name: 'Categories',
    components: {Pagination},
    props: ['type', 'title'],
    data(){
      return {
        buttonLoading: false,
        currentPage: 1,
        totalRows: 1,
        fields: [
          { key: 'name', label: 'Başlık' },
          // { key: 'parent_name', label: 'Üst Kategori' },
          { key: 'action', label: 'İşlem', thStyle: {width: '100px !important'} },
        ],
        lastPage:1,
        categoryOptions: [],
        modal: {
          name: '',
          parent: null,
          type: '',
        },
      }
    },
    methods: {
      ...mapActions(['getCategories', 'createCategory', 'updateCategory', 'deleteCategory']),
      changePage(e){
        this.currentPage=e
        this.$refs.table.refresh()
      },
      submit(){
        this.buttonLoading = true;
        if( this.modal.id ) {
          this.updateCategory(this.modal)
            .then(res => {
              this.success(res.data.message);
              this.$refs.table.refresh();
              this.buttonLoading = false;
              this.$refs.modal.hide();
            }).catch(error => {
              this.buttonLoading = false;
              this.error(error.response.data.message);
            });
        } else {
          this.createCategory(this.modal)
            .then(res => {
              this.success(res.data.message);
              this.buttonLoading = false;
              this.$refs.table.refresh();
              this.$refs.modal.hide();
            }).catch(error => {
              this.buttonLoading = false;
              this.error(error.response.data.message);
            });
        }
      },
      deleteAction(id) {
        this.$swal({
          icon: 'warning',
          title: 'Dikkat',
          text: 'Kayıt silinecektir, emin misiniz?'
        }).then(ok => {
          if (ok.value) {
            this.deleteCategory(id)
              .then(res => {
                this.success(res.data.message);
                this.$refs.table.refresh();
              })
              .catch(err => {
                const error = err.message ? err.message : err.response.data;
                this.error(error);
              });
          }
        });
      },
      hideModal() {
        this.modal = {
          name: '',
          type: this.type,
          parent: null,
        };
      },
      openModal(data) {
        this.modal = data;
        this.modal.parent = this.categoryOptions.find(item => item.value === data.parent_id);
        this.showModal();
      },
      showModal() {
        this.$refs.modal.show();
      },
      items() {
        return this.getCategories(this.parameters()).then(json => json.data).then(res => {
          this.currentPage = res.current_page;
          this.lastPage=res.last_page
          this.totalRows = res.total;
          return res.data;
        });
      },
      parameters() {
        const params = {};
        params.type = this.type;
        params.page=this.currentPage

        return params;
      }
    },
    mounted() {
      this.modal.type = this.type;
    },
  }
</script>
